import React from 'react';

export interface HealthBubbleProps {
  type?: 'failing' | 'halting' | 'ok' | string;
  width?: number;
  style?: React.CSSProperties;
}

function HealthBubble({ type, width = 13, style: customStyle }: HealthBubbleProps) {
  let color: string | undefined;
  if (type === 'failing') {
    color = '#FF2C2C';
  } else if (type === 'halting') {
    color = '#FFE72C';
  } else if (type === 'ok') {
    color = '#6FE20D';
  }
  const style: React.CSSProperties = {
    display: 'inline-block',
    background: color,
    width,
    height: width,
    borderRadius: '50%',
    border: '1px solid #70707057',
    ...customStyle,
  };
  return <div style={style}></div>;
}

export default HealthBubble;
